import { useEffect, useState } from "react";

export default function UIHero() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(t);
  }, []);

  return (
    <section className="relative min-h-[92vh] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=premium%20residential%20villa%20plot%20layout%20aerial%20view%20Sarjapur%20Road%20Bangalore%20India%20green%20trees%20wide%20roads%20gated%20community%20beautiful%20landscape%20sunrise&width=1600&height=900&seq=uihero01&orientation=landscape"
          alt="Urban Infra villa plots Sarjapur Road Bangalore"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#1B2A4A]/80 via-[#1B2A4A]/60 to-[#1B2A4A]/30"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8 w-full py-20">
        <div className={`flex items-center gap-2 text-white/70 text-sm mb-6 transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <a href="/" className="hover:text-white transition-colors cursor-pointer">Home</a>
          <i className="ri-arrow-right-s-line text-[#7FBF3F]"></i>
          <span className="text-white">Projects</span>
        </div>

        <div className={`inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 text-white/80 text-xs font-semibold px-4 py-2 rounded-full mb-6 transition-all duration-700 delay-100 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <i className="ri-leaf-line text-[#7FBF3F]"></i>
          Eco-Friendly Residential Developments
        </div>

        <h1
          className={`text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight transition-all duration-700 delay-200 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          Our <span className="text-[#7FBF3F]">Projects</span>
        </h1>

        <p className={`text-lg md:text-xl text-white/85 max-w-2xl mb-10 leading-relaxed transition-all duration-700 delay-300 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          Explore eco-friendly villa plots and premium residential layouts in Sarjapur Road, Bengaluru — built for peaceful living and long-term investment value.
        </p>

        <div className={`flex flex-col sm:flex-row gap-4 transition-all duration-700 delay-400 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <a href="#projects-grid" className="inline-flex items-center justify-center gap-2 bg-[#7FBF3F] hover:bg-[#6aaa32] text-white font-semibold px-8 py-4 rounded-lg transition-all duration-300 cursor-pointer whitespace-nowrap text-base">
            <i className="ri-building-2-line"></i>View Projects
          </a>
          <a href="/contact" className="inline-flex items-center justify-center gap-2 bg-white hover:bg-gray-50 text-[#1B2A4A] font-semibold px-8 py-4 rounded-lg transition-all duration-300 cursor-pointer whitespace-nowrap text-base">
            <i className="ri-calendar-check-line"></i>Book Now
          </a>
        </div>

        <div className={`mt-16 grid grid-cols-2 md:grid-cols-4 gap-6 transition-all duration-700 delay-500 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          {[
            { value: "9+", label: "Projects Delivered" },
            { value: "500+", label: "Happy Families" },
            { value: "2", label: "Ongoing Projects" },
            { value: "10+", label: "Years Experience" },
          ].map((stat) => (
            <div key={stat.label} className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl p-4 text-center">
              <div className="text-3xl font-bold text-[#7FBF3F] mb-1" style={{ fontFamily: "'Playfair Display', serif" }}>{stat.value}</div>
              <div className="text-white/80 text-xs">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/50 text-xs animate-bounce">
        <span>Scroll</span>
        <i className="ri-arrow-down-line"></i>
      </div>
    </section>
  );
}
